var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all-done-container"},[_c('Typography',{attrs:{"variant":"h-2"}},[_vm._v("All done!")]),_c('Robin',{attrs:{"height":120,"width":140,"loop":false,"animation":"backflip"}}),_c('Button',{on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(" Close ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }